import { StaticPricingTab } from './pricing-display-static.types';

export const TOOLKIT_ON_PREMISE_TAB: StaticPricingTab = {
  id: 'toolkit-on-premise',
  label: 'Toolkit On Premise',
  sections: [
    {
      title: 'AccuZIPToolkit API (COM Object) - LAN',
      headers: [
        'Code',
        'Product',
        'Evaluation Fee',
        '1 year',
        '2 years',
        '3 years',
      ],
      // Codes 900 (CASS LAN) and 902 (RDI LAN). Main row = price,
      // "- Additional Licenses" row = site_price.
      rows: [],
      dynamicSource: 'toolkit',
      dynamicCodes: ['900', '902'],
    },
    {
      title: 'AccuZIPToolkit API (COM Object) - WAN',
      headers: [
        'Code',
        'Product',
        'Evaluation Fee',
        '1 year',
        '2 years',
        '3 years',
      ],
      rows: [],
      dynamicSource: 'toolkit',
      dynamicCodes: ['901'],
    },
    {
      title: 'AccuZIPToolkit API (COM Object) - DEVELOPER',
      headers: [
        'Code',
        'Product',
        'Evaluation Fee',
        '1 year',
        '2 years',
        '3 years',
      ],
      rows: [],
      dynamicSource: 'toolkit',
      dynamicCodes: ['903'],
      notes: [
        {
          type: 'paragraph',
          text: 'One Production Server / One Development Server - Internal',
        },
      ],
    },
    {
      title: 'AccuZIPToolkit Addons',
      headers: [
        'Product',
        'One Year Contract',
        'Two Year Contract',
        'Three Year Contract',
      ],
      rows: [
        ['AccuGeocoder', '$1,555', '$2,800', '$3,730'],
        ['Z4Change (Site License Fee)', '$3,750', '$6,750', '$9,000'],
        ['Canadian Address Verification', '$1,555', '$2,800', '$3,730'],
        ['Residential Delivery Indicator (RDI)', '$370', '$665', '$890'],
      ],
    },
    {
      title: 'AccuZIPToolkit API (COM Object) - OEM',
      headers: [
        'Product',
        'License Count (From)',
        'License Count (To)',
        'Annual',
        'Canadian Address Verification Annual',
        'Residential Delivery Indicator Annual',
        'AccuGeocoder Annual',
      ],
      rows: [
        [
          'RESELLER LICENSE FEE',
          '-',
          '-',
          '$20,000',
          '$2,000',
          '$200',
          '$2,000',
        ],
        ['Additional Licenses', '1', '100', '$2,475', '$743', '$124', '$743'],
        [
          'Additional Licenses',
          '101',
          '200',
          '$5,040',
          '$1,512',
          '$252',
          '$1,512',
        ],
        [
          'Additional Licenses',
          '201',
          '300',
          '$7,560',
          '$2,268',
          '$378',
          '$2,268',
        ],
        [
          'Additional Licenses',
          '301',
          '400',
          '$10,080',
          '$3,024',
          '$504',
          '$3,024',
        ],
        [
          'Additional Licenses',
          '401',
          '500',
          '$12,645',
          '$3,794',
          '$632',
          '$3,794',
        ],
        [
          'Additional Licenses',
          '501',
          '600',
          '$15,210',
          '$4,563',
          '$761',
          '$4,563',
        ],
        [
          'Additional Licenses',
          '601',
          '700',
          '$17,595',
          '$5,279',
          '$880',
          '$5,279',
        ],
        [
          'Additional Licenses',
          '701',
          '800',
          '$20,295',
          '$6,089',
          '$1,015',
          '$6,089',
        ],
        [
          'Additional Licenses',
          '801',
          '900',
          '$22,950',
          '$6,885',
          '$1,148',
          '$6,885',
        ],
        [
          'Additional Licenses',
          '901',
          '1,000',
          '$25,245',
          '$7,574',
          '$1,262',
          '$7,574',
        ],
        [
          'Additional Licenses',
          '1,001',
          '10,000',
          '$32,715',
          '$9,815',
          '$1,636',
          '$9,815',
        ],
        [
          'Additional Licenses',
          '10,001',
          '20,000',
          '$40,185',
          '$12,056',
          '$2,009',
          '$12,056',
        ],
        [
          'Additional Licenses',
          '20,001',
          '30,000',
          '$48,105',
          '$14,432',
          '$2,405',
          '$14,432',
        ],
        [
          'Additional Licenses',
          '30,001',
          '40,000',
          '$55,665',
          '$16,700',
          '$2,783',
          '$16,700',
        ],
      ],
    },
  ],
};
